import Api from "@/helpers/api.js";

export default {
	namespaced: true,
	state: {
		configList: [],
	},
	actions: {
		fetchCompanyConfigList({commit}) {
			return new Promise((resolve, reject) => {
				Api.get("/config/company")
					.then((res) => {
						commit("setConfigs", res.data);
						resolve(res);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},
	},
	mutations: {
		setConfigs(state, configs) {
			state.configList = configs;
		},
	},
	getters: {
		visualConfig(state) {
			return state.configList.find((config) => config.type_config_name === "VISUAL_CONFIG");
		},
	},
};
